import { render, staticRenderFns } from "./ResidentManager.vue?vue&type=template&id=57e79650&scoped=true"
import script from "./ResidentManager.vue?vue&type=script&lang=js"
export * from "./ResidentManager.vue?vue&type=script&lang=js"
import style0 from "./ResidentManager.vue?vue&type=style&index=0&id=57e79650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e79650",
  null
  
)

export default component.exports